import { render, staticRenderFns } from "./document-masters.vue?vue&type=template&id=2fcebf4e&"
import script from "./js/document-masters.js?vue&type=script&lang=js&"
export * from "./js/document-masters.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports